<!--@prettier-->
<template>
  <Button
    ref="skipLink"
    class="skip-link"
    label="Skip to main content"
    @click="skipToMainContent()"
  />
</template>

<script setup>
  const skipToMainContent = () => document.querySelector(".layout-main").focus();
</script>

<style scoped lang="scss">
  .skip-link {
    white-space: nowrap;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 119px;
    opacity: 0;
    z-index: 999;
    padding: 0.4rem 1.5rem 0.5rem 1.5rem;
    pointer-events: none;
    border-radius: 0 0 0.25rem 0.25rem;
    font-size: 0.875rem;
    background-color: var(--color-background);
    &:enabled:focus {
      background-color: var(--color-background);
      color: var(--color-primary);
      opacity: 1;
      pointer-events: auto;
      outline: 3px solid rgba(var(--color-primary-rgb), 0.5);
    }
  }
</style>
